import { LOGIN, LOGIN_SUCCESS, LOGOUT, UPDATE_AUTH_DATA } from '../mutation_types.js'

export default {
  namespaced: true,
  state: {
    isLoggedIn: !!sessionStorage.getItem('token'),
    pending: false,
    loggedInUser: sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '',
    authUsername: sessionStorage.getItem('apiUser') ? sessionStorage.getItem('apiUser') : '',
    authPassword: sessionStorage.getItem('apiToken') ? sessionStorage.getItem('apiToken') : ''
  },
  getters: {
    getLoginStatus: state => {
      return state.isLoggedIn
    },
    getLoggedInUser: state => {
      return state.loggedInUser
    },
    getAuthUser: state => {
      return state.authUsername
    },
    getAuthPassword: state => {
      return state.authPassword
    }
  },
  mutations: {
    [LOGIN] (state) {
      state.pending = true
    },
    [LOGIN_SUCCESS] (state) {
      state.isLoggedIn = true
      state.pending = false
      state.loggedInUser = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : ''
    },
    [LOGOUT] (state) {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('apiToken')
      sessionStorage.removeItem('apiUser')
      state.isLoggedIn = false
      state.loggedInUser = ''
      state.authUsername = ''
      state.authPassword = ''
    },
    [UPDATE_AUTH_DATA] (state, authData) {
      sessionStorage.setItem('apiToken', authData.api_pass)
      sessionStorage.setItem('apiUser', authData.api_user)
      state.authUsername = sessionStorage.getItem('apiUser')
      state.authPassword = sessionStorage.getItem('apiToken')
    }
  },
  actions: {
    login ({commit}, currentUser) {
      commit(LOGIN)
      return new Promise(resolve => {
        setTimeout(() => {
          sessionStorage.setItem('token', currentUser)
          commit(LOGIN_SUCCESS)
          resolve()
        }, 1000)
      })
    },
    logout ({commit}) {
      commit(LOGOUT)
    },
    updateAuthData ({commit}, authData) {
      commit(UPDATE_AUTH_DATA, authData)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin_user_store.js